import { useAtomValue, useSetAtom } from "jotai";
import { MediaIcon } from "@/icons/widget-menu";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";
import { buildImageInput } from "../buildImageInput";
import { handleMediaInputChange } from "../handleMediaInputChange";
import { setNewOptions } from "../setNewOptions";

interface UseMediaButtonProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function useMediaButton({ setActiveSubMenu }: UseMediaButtonProps): MenuOptionResult {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("media"));
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const handleClick = () => {
        setActiveSubMenu(null);

        const input = buildImageInput();

        const setMediaOptions = setNewOptions({ name: "media", setWidgetMenuOptions });

        if (input) {
            input.click();
            input.addEventListener("change", handleMediaInputChange(options, setMediaOptions));
        }
    };

    return {
        content: <MediaIcon />,
        handleClick,
    };
}
